export default __webpack_public_path__ + "static/media/img_project_success.47275f02.png";